import { Icon } from "@components/icon";
import { Loader } from "@components/loader/loader";
import { PressItemsList } from "@components/press_items_list/press_items_list";
import { useFetchPressItems } from "@hooks/use_fetch_press_items";
import React, { type FC } from "react";

const PressItemIndexPage: FC = () => {
  const { pressItems, loading } = useFetchPressItems();

  if (loading) {
    return <Loader />;
  }
  if (!pressItems) {
    return null;
  }

  return (
    <div className="content">
      <header>
        <h1>Press</h1>
        <div className="controls">
          <a href="/admin/press/new" className="add_new" title="Add press">
            <Icon name="plus" />
          </a>
        </div>
      </header>

      <p>
        This page manages a list of press items about 1890 Bryant. Eventually
        these show up on the main site under the `press` department.
      </p>
      <PressItemsList pressItems={pressItems} />
    </div>
  );
};

export { PressItemIndexPage };
